module.exports = __webpack_public_path__ + "img/awardBack2.1dd61bfc.png";